import * as Sentry from '@sentry/sveltekit';
import { sentrySettings } from '$lib/sentry';

// Browser errors (src/lib/sentry.js). Without PUBLIC_SENTRY_DSN, Sentry is
// never initialised and handleErrorWithSentry only passes errors through.
const settings = sentrySettings();
if (settings) {
   // The commit this build was made from (vite.config.ts; version.json).
   Sentry.init({ dsn: settings.dsn, environment: settings.environment, release: __BUILD_VERSION__.commit, sendDefaultPii: false });
}

export const handleError = Sentry.handleErrorWithSentry();
